"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { PatientDynamicFieldType } from "@/types/enums/patient-health-field";
import PatientHealthFieldDialog from "./patient-health-field-dialog";
const MEDICATIONS_CONFIG = {
  type: PatientDynamicFieldType.MEDICATIONS,
  title: "Patient Medications",
  description: "Add medications that the patient is currently taking. Information from patient forms will appear here automatically.",
  placeholder: "e.g., Ibuprofen 200mg",
  addButtonText: "Add medication",
  addAnotherButtonText: "Add another medication"
};
interface PatientMedicationsDialogProps {
  children?: ReactNode;
  patientId: string;
}
export default function PatientMedicationsDialog(t0) {
  const $ = _c(3);
  const {
    children,
    patientId
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== patientId) {
    t1 = <PatientHealthFieldDialog config={MEDICATIONS_CONFIG} patientId={patientId}>{children}</PatientHealthFieldDialog>;
    $[0] = children;
    $[1] = patientId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}